/** Admin: create a subscription plan for one owner (owner-twin). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../src/context/OwnerScopeContext';
import AddPlanScreen from '../../../../owner/subscriptions/add-plan';

export default function AdminOwnerAddPlanScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <AddPlanScreen />
    </OwnerScopeProvider>
  );
}
